<template>
  <v-checkbox
    v-model="selected"
    :disabled="item.disabled"
    :value="item.value"
    :label="item.text"
    hide-details
    class="pa-0 ma-0"
    :multiple="multiple"
  >
    <template #label>
      <slot v-if="$scopedSlots.label" name="label" :item="item" />
      <div class="label_item" v-else>
        <p class="ma-0 pa-0text-body-1 text--primary">
          {{ item.text }}
        </p>
      </div>
    </template>
  </v-checkbox>
</template>
<script>
export default {
  name: "SimpleCheckbox",
  props: {
    item: Object,
    value: [Array, String],
    multiple: Boolean
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
<style lang=""></style>
